export var ThreeDSChallengeStatus;
(function (ThreeDSChallengeStatus) {
    ThreeDSChallengeStatus["PENDING"] = "PENDING";
    ThreeDSChallengeStatus["APPROVED"] = "APPROVED";
    ThreeDSChallengeStatus["DECLINED"] = "DECLINED";
    ThreeDSChallengeStatus["TIMED_OUT"] = "TIMED_OUT";
    ThreeDSChallengeStatus["ERROR"] = "ERROR";
})(ThreeDSChallengeStatus || (ThreeDSChallengeStatus = {}));
export var ThreeDSChallengeSource;
(function (ThreeDSChallengeSource) {
    ThreeDSChallengeSource["PAYCENTER"] = "PAYCENTER";
    ThreeDSChallengeSource["INTERNAL"] = "INTERNAL";
})(ThreeDSChallengeSource || (ThreeDSChallengeSource = {}));
export var ThreeDSAuthenticationMethod;
(function (ThreeDSAuthenticationMethod) {
    ThreeDSAuthenticationMethod["OOB_BIOMETRICS"] = "OOB_BIOMETRICS";
    ThreeDSAuthenticationMethod["STATIC_PASSCODE"] = "STATIC_PASSCODE";
    ThreeDSAuthenticationMethod["OOB_OTHER"] = "OOB_OTHER";
})(ThreeDSAuthenticationMethod || (ThreeDSAuthenticationMethod = {}));
//# sourceMappingURL=three-ds.types.js.map